import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=2aa9eed3&scoped=true"
import script from "./Metadata.vue?vue&type=script&lang=js"
export * from "./Metadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa9eed3",
  null
  
)

export default component.exports